import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-search",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    return {
      isPopSearch: false,
      timeout: null,
      time: 1,
      searchText: "",
      searchObj: null,
      isLoading: false
    };
  },
  watch: {
    isPopSearch(bool) {
      if (!bool) {
        this.registerBodyClick(false, this.onClose);
      } else {
        this.registerBodyClick(true, this.onClose);
      }
    }
  },
  methods: {
    ...userVuex.mapActions(["getTokenInfo"]),
    async searchTokenInfo() {
      const detail = await this.getTokenInfo({
        token: this.searchText
      });
      console.log("detail", detail);
      if (detail && detail.hasOwnProperty("code") && detail.code > 0) {
        this.searchObj = detail.data;
        return;
      }
      this.searchObj = detail;
    },
    onSearchInput() {
      console.log("this.searchText", this.searchText);
      if (this.searchText === "") {
        this.onClose();
        return;
      }
      this.isPopSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.searchTokenInfo();
        this.isLoading = false;
      }, this.time * 1000);
      this.isLoading = true;
    },
    onSkip() {
      this.$router.push(this.$router.push(`/token/${this.searchObj.address}`));
    },
    onClose() {
      this.isPopSearch = false;
      clearTimeout(this.timeout);
      this.searchText = "";
      this.searchObj = null;
      this.isLoading = false;
    }
  },
  mounted() {}
};